import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfBH",
  "use": "BankOfBH-usage",
  "viewBox": "0 0 69.68 69.395",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 69.68 69.395\" id=\"BankOfBH\">\r\n  <defs>\r\n    <style>\r\n      #BankOfBH .cls-1 {\r\n        fill: #68ca3f;\r\n      }\r\n\r\n      #BankOfBH .cls-1, #BankOfBH .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      #BankOfBH .cls-2 {\r\n        fill: #00349a;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfBH_形状_1179_拷贝\" data-name=\"形状 1179 拷贝\" class=\"cls-1\" d=\"M3996.99,492.541s8.04-4.021,15.19,0c0,0,19.44-7.6,35.3.224,0,0,6.26-6.479-6.25-9.16a24.528,24.528,0,0,0-20.78,4.915s-11.4-8.044-23.46,4.021\" transform=\"translate(-3985.16 -468.053)\" />\r\n  <path id=\"BankOfBH_形状_1179_拷贝_2\" data-name=\"形状 1179 拷贝 2\" class=\"cls-2\" d=\"M3985.14,510.862s34.41-20.108,59.44,11.618l10.28-20.778s-6.26-12.735-27.71-10.725a66.43,66.43,0,0,0-42.01,19.885\" transform=\"translate(-3985.16 -468.053)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfBH.svg
// module id = uVQg
// module chunks = 37